import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const TypingText = ({ 
  text = "", 
  speed = 80, 
  delay = 0, 
  classText = "intro" 
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!text || typeof text !== 'string') return;

    setDisplayedText('');
    setCurrentIndex(0);

    const startTyping = () => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          if (prevIndex < text.length) {
            setDisplayedText((prevText) => prevText + text.charAt(prevIndex));
            return prevIndex + 1;
          } else {
            clearInterval(interval);
            return prevIndex;
          }
        });
      }, speed);
    };

    const timer = setTimeout(startTyping, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [text, speed, delay]);

  return (
      <span className={classText}>
        {displayedText}
        </span>
  );
};

TypingText.propTypes = {
  text: PropTypes.string.isRequired,
  speed: PropTypes.number,
  delay: PropTypes.number,
  classText: PropTypes.string,
};

export default TypingText;
